module.exports = __webpack_public_path__ + "img/arrow_down_square.8102575e.svg";